import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [AvatarModule, AvatarGroupModule, CommonModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
})
export class UserAvatarComponent {
  readonly label = input<string>();
  readonly icon = input<string>();
  readonly imgSrc = input<string>();
  readonly shape = input<'circle' | 'square'>('circle');
  readonly active = input(false);
  readonly showActiveIndicator = input(true);
  readonly size = input<'2xsm' | 'xsm' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'>('lg');
}
